import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useEffect, useCallback } from 'react';
import TableHeader from './TableHeader.js';
import TableBody from './TableBody.js';
import HeaderCell from './HeaderCell.js';
import BodyCell from './BodyCell.js';
import { TableContext } from './tableContext.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'prop-types';
import '@elliemae/ds-shared/createDataInstance/utils';
import '@elliemae/ds-basic/TruncatedTooltipText';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '@elliemae/ds-shared/FocusGroup/FocusGrid';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Provider = TableContext.Provider;

function Table(props) {
  var renderers = props.decoratedRenderers,
      columns = props.decoratedColumns,
      getRowProps = props.getRowProps,
      getHeaderRowProps = props.getHeaderRowProps,
      getTableProps = props.getTableProps,
      children = props.children,
      tableRef = props.tableRef,
      wrapText = props.props.wrapText,
      style = props.style,
      _props$onDefaultFilte = props.onDefaultFiltersLoad,
      onDefaultFiltersLoad = _props$onDefaultFilte === void 0 ? function () {
    return null;
  } : _props$onDefaultFilte;
  useEffect(function () {
    onDefaultFiltersLoad(props.composedRows);
  }, [onDefaultFiltersLoad]);

  var headerRowRenderer = function headerRowRenderer() {
    var Row = renderers.header.row;
    var Cell = renderers.header.cell;
    var cells = []; // optimize the rendering using for loop

    for (var index = 0; index < columns.length; index++) {
      cells.push( /*#__PURE__*/React.createElement(HeaderCell, {
        key: index,
        classProps: {
          wrapText: wrapText
        },
        column: columns[index],
        columnIndex: index,
        component: Cell,
        grid: props
      }));
    }

    var rowProps = getHeaderRowProps({}, {});
    return /*#__PURE__*/React.createElement(Row, rowProps, cells);
  };

  var bodyRowRenderer = useCallback(function (rowData, rowProps, extraParams) {
    var Row = renderers.body.row;
    var Cell = renderers.body.cell;
    var nextRowProps = getRowProps(rowProps, _objectSpread(_objectSpread({}, extraParams), {}, {
      rowData: rowData
    })); // get cells from columns api

    var cells = []; // optimize the rendering using for loop

    for (var index = 0; index < columns.length; index++) {
      cells.push( /*#__PURE__*/React.createElement(BodyCell, {
        key: index,
        classProps: {
          wrapText: wrapText
        },
        column: columns[index],
        columnIndex: index,
        component: Cell,
        grid: props,
        rowIndex: extraParams.rowIndex,
        rowProps: _objectSpread({
          rowData: rowData
        }, nextRowProps)
      }));
    }

    return /*#__PURE__*/React.createElement(Row, _extends({}, nextRowProps, {
      rowData: rowData
    }), cells);
  }, [columns, renderers]);
  var TableComponent = renderers.table;

  var value = _objectSpread(_objectSpread({}, props), {}, {
    bodyRowRenderer: bodyRowRenderer,
    headerRowRenderer: headerRowRenderer
  });

  return /*#__PURE__*/React.createElement(Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(TableComponent, getTableProps({
    innerRef: tableRef,
    style: style
  }), children));
}

Table.Header = TableHeader;
Table.Body = TableBody;

export default Table;
//# sourceMappingURL=Table.js.map
